import React from "react";
import { Button } from "primereact/button";
import { useSelector } from "react-redux";

import PermissionGate from "~/components/PermissionGate";
import AddressFileds from "../AddressFileds";
import SuccessNotification from "../SuccessNotification";
import Banner from "../../..//Banner";
import banner from "../../../../assets/images/banner.png";

const RegisteredAddress = ({
  state,
  handleEditClick,
  handleRegisterDiscard,
  handleRegisterSave,
  RegisterAddressOnchange,
  entityPlusEnable,
  setAuditSidebarVisible,
  entityId,
}) => {
  const { role } = useSelector((state) => state.login);

  return (
    <>
      {state?.successMsg && entityPlusEnable && (
        <SuccessNotification successMsg={state.successMsg} />
      )}
      <div
        className={`flex justify-content-between align-items-center ${entityPlusEnable && "mb-5"} ${!state?.successMsg && !entityPlusEnable && "mb-5"} ${entityPlusEnable && "mt-4"} w-full`}
      >
        <h4
          className={` m-0 ${!entityPlusEnable ? "no-entity-plus-heading" : "address-heading"}`}
        >
          Registered Address
        </h4>

        <PermissionGate
          resource="entity"
          action="modify"
          resourceAttr={{ entity_id: entityId }}
        >
          <div className="flex gap-2  align-items-center">
            {state?.isEditingEnabled ? (
              <>
                <button className="discard-btn" onClick={handleRegisterDiscard}>
                  Discard
                </button>
                <Button
                  className={`save-btn ${state?.isSaveEnabledRegistered && "disable"}`}
                  loading={state?.isUpdateLoading}
                  onClick={handleRegisterSave}
                  disabled={
                    state?.isUpdateLoading || state?.isSaveEnabledRegistered
                  }
                >
                  {!state?.isUpdateLoading && "Save Changes"}
                </Button>
              </>
            ) : (
              <>
                {!entityPlusEnable && (
                  <button
                    className="add-address-button"
                    onClick={() => setAuditSidebarVisible(true)}
                  >
                    View History <span className="pi pi-history mb-1 ml-2" />
                  </button>
                )}
                <button className="add-edit-btn" onClick={handleEditClick}>
                  Edit <span className="pi pi-pencil text-xs ml-2"></span>
                </button>
              </>
            )}
          </div>
        </PermissionGate>
      </div>
      {state?.successMsg && !entityPlusEnable && (
        <div className="w-full mb-5">
          <SuccessNotification successMsg={state.successMsg} />
        </div>
      )}
      <div className="grid w-full">
        <AddressFileds
          data={state?.registerAddress}
          isEdit={state?.isEditingEnabled && ["GXM_ADMIN"].includes(role)}
          isLoading={state?.isLoading}
          handleOnchange={RegisterAddressOnchange}
        />
      </div>
      {!entityPlusEnable && state?.isEntityLoading && (
        <>
          <div className="col-12 p-0 mb-3">
            <hr className="banner-border" />
          </div>
          <div className=" w-full">
            <Banner
              image={banner}
              title="Want to add more addresses?"
              description="Unlock this and other features with an Entities Plus subscription."
              onClick={() => {}}
            />
          </div>
        </>
      )}
    </>
  );
};

export default RegisteredAddress;
